import client from '../core/client';
import { getBodyData } from '../utils';

export default ({ email }) => getBodyData(client.post('/v1/form/token/send/', { email }));
